import React from 'react';
import { Clock, Shield, Headphones, TrendingUp, Package, Award } from 'lucide-react';

const benefits = [
  {
    icon: Clock,
    title: 'Schnelle Lieferung',
    description: 'Deutschlandweite Lieferung innerhalb von 24-48 Stunden'
  },
  {
    icon: Shield,
    title: 'Geprüfte Qualität',
    description: 'Alle Materialien von renommierten Herstellern'
  },
  {
    icon: Headphones,
    title: 'Persönliche Beratung',
    description: 'Fachkundige Unterstützung bei der Materialauswahl'
  },
  {
    icon: TrendingUp,
    title: 'Faire Konditionen',
    description: 'Transparente Preise und flexible Zahlungsbedingungen'
  },
  {
    icon: Package,
    title: 'Komplettlösungen',
    description: 'Alle Materialien für Ihr Projekt aus einer Hand'
  },
  {
    icon: Award,
    title: 'Langjährige Erfahrung',
    description: 'Expertise im Baustoffhandel seit vielen Jahren'
  }
];

export const WhyKalemSection = () => {
  return (
    <section id="warum-kalem" className="py-20 lg:py-32 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-gray-50 to-transparent"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-[#8B1538]/10 text-[#8B1538] text-sm font-semibold mb-4">
            Ihre Vorteile
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Warum KALEM Baustoffhandel?
          </h2>
          <p className="text-xl text-gray-600">
            Profitieren Sie von unserer langjährigen Erfahrung und unserem umfassenden Service
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
                className="group p-8 rounded-xl border-2 border-gray-200 hover:border-[#8B1538] bg-white hover:shadow-xl transition-all duration-300"
              >
                <div className="mb-5">
                  <div className="w-14 h-14 rounded-lg bg-[#8B1538]/10 flex items-center justify-center group-hover:bg-[#8B1538] transition-all duration-300">
                    <Icon className="w-7 h-7 text-[#8B1538] group-hover:text-white transition-colors duration-300" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#8B1538] transition-colors">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Trust Section */}
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-12 lg:p-16 text-white text-center">
          <h3 className="text-3xl lg:text-4xl font-bold mb-6">
            Vertrauen Sie auf einen starken Partner
          </h3>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Hunderte Bauunternehmen und Handwerksbetriebe vertrauen bereits auf unsere Qualität und Zuverlässigkeit. Werden auch Sie Teil unseres Netzwerks.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('kontakt');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center px-8 py-4 bg-[#8B1538] hover:bg-[#6B0F2A] text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
          >
            Jetzt Kontakt aufnehmen
          </button>
        </div>
      </div>
    </section>
  );
};